"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const appStateSelectBOFontSize_1 = __importDefault(require("../shared/appStateSelectBOFontSize"));
const useAppStateSelector_1 = __importDefault(require("./useAppStateSelector"));
const controlFontSizeCompute_1 = __importDefault(require("../shared/controlFontSizeCompute"));
const useAppGetFontSizeFromSpecification = () => {
    const globalFontSize = (0, useAppStateSelector_1.default)(appStateSelectBOFontSize_1.default);
    return (0, react_1.useCallback)((fontSize) => (0, controlFontSizeCompute_1.default)({
        globalFontSize,
        fontSize,
    }), [globalFontSize]);
};
exports.default = useAppGetFontSizeFromSpecification;
